import { gql } from '@/lib/graphql/gql'

export const STATIC_SITE_DISPLAY_NAME_QUERY = gql`
  query StaticSiteDisplayName($staticSiteName: String!) {
    staticSite(name: $staticSiteName) {
      id
      source
      idCompany
      idProject
      name
      displayName
    }
  }
`
